<div class="page-inner-body portlet light">
  <div class="portlet-body px-0">
    <div class="table-toolbar">
      <div class="page-header-section">
        <div class="d-flex justify-content-between align-items-start">
          <div>
            <div class="d-flex align-items-center">
              <h5 class="page-title mb-0">{{ 'productSocialMediaShares.title' | transloco }}</h5>
            </div>
          </div>
        </div>
        <div class="filters-container mt-3">
          <div class="d-flex flex-wrap align-items-center gap-2">
            <div class="flex-fill" style="min-width: 180px;" *ngIf="authConfig.IsArtist">
              <p-dropdown [options]="artistProdusts" inputId="Product" [filter]="true" [filterBy]="'label'"
                [optionLabel]="'label'" [(ngModel)]="filter.productId" [optionValue]="'value'" name="Name"
                [placeholder]="'productSocialMediaShares.filterProduct' | transloco" [showClear]="true" styleClass="w-100"
                (onChange)="onArtistProductsChange($event)">
              </p-dropdown>
            </div>
            <div class="flex-fill" style="min-width: 180px;" *ngIf="authConfig.IsGallery">
              <p-dropdown [options]="galleryProducts" inputId="Product" [filter]="true" [filterBy]="'label'"
                [optionLabel]="'label'" [(ngModel)]="filter.productId" [optionValue]="'value'" name="Name"
                [placeholder]="'productSocialMediaShares.filterProduct' | transloco" [showClear]="true" styleClass="w-100"
                (onChange)="onGalleryProductsChange($event)">
              </p-dropdown>
            </div>
            <div class="flex-fill" style="min-width: 180px;" *ngIf="authConfig.IsGallery">
              <p-dropdown [options]="artists" inputId="Userid" name="Userid" [filter]="true" [filterBy]="'label'"
                [(ngModel)]="filter.filterUserId" [optionLabel]="'label'" [optionValue]="'value'" [showClear]="true"
                (onChange)="onArtistsChange($event)" [placeholder]="'productSocialMediaShares.filterByArtist' | transloco" styleClass="w-100">
              </p-dropdown>
            </div>
            <div class="flex-fill" style="min-width: 180px;" *ngIf="authConfig.IsArtist">
              <p-dropdown [options]="galleries" inputId="Userid" name="Userid" [filter]="true" [filterBy]="'label'"
                [(ngModel)]="filter.filterUserId" [optionLabel]="'label'" [optionValue]="'value'" [showClear]="true"
                (onChange)="onGalleriesChange($event)" [placeholder]="'productSocialMediaShares.filterByGallery' | transloco" styleClass="w-100">
              </p-dropdown>
            </div>
            <div>
              <p-button type="button" icon="pi pi-times" iconPos="left" [outlined]="true" severity="secondary"
                (click)="clearAllFilters()" class="p-button-sm" [label]="'productSocialMediaShares.clearAll' | transloco"></p-button>
            </div>
          </div>
        </div>
      </div>
      <!-- <p-tabView> -->
      <!-- Artist Posts Tab -->
      <ng-container *ngIf="isArtist">
        <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="selectedTabIndex">
          <p-tabPanel [header]="'productSocialMediaShares.artistPosts' | transloco" [disabled]="filter.productId == null && filter.filterUserId != null">
            <div class="row my-2 p-1">
              <div class="col d-flex justify-content-start p-2">
                <div class="d-flex justify-content-end align-items-center flex-wrap">
                  <div class="d-flex flex-column align-items-start me-3">
                    <div class="d-flex align-items-center">
                      <p-inputSwitch class="mt-1" [(ngModel)]="filterByFacebook" (onChange)="filterSocialPosts('artist', 'Facebook', $event)"></p-inputSwitch>
                      <span class="ms-2 fw-semibold">{{ 'productSocialMediaShares.filterByFacebook' | transloco }}</span>
                    </div>
                  </div>
                  <div class="d-flex flex-column align-items-start me-3">
                    <div class="d-flex align-items-center">
                      <p-inputSwitch class="mt-1" [(ngModel)]="filterByInstagram" (onChange)="filterSocialPosts('artist', 'Instagram',$event)"></p-inputSwitch>
                      <span class="ms-2 fw-semibold">{{ 'productSocialMediaShares.filterByInstagram' | transloco }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cmultical" *ngIf="artistPosts.length > 0">
              <div class="post shadow mb-2 rounded" *ngFor="let post of artistPosts">
                <!-- Post Header: Profile Image & Name -->
                <div class="d-flex align-items-center justify-content-between ">
                  <!-- Profile Image & Name -->
                  <div class="d-flex align-items-center mb-2">
                    <img
                      [src]="getProfilePicture(post)"
                      class="rounded-circle profile-img me-2" [alt]="'productSocialMediaShares.profile' | transloco" style="width: 35px; height: 35px;"
                      (error)="onImageError($event)">
                    <div>
                      <div class="fw-semibold small-text">
                        {{ getProfileName(post)  }}
                      </div>
                      <small class="text-muted">
                        {{ post.CreatedDate | date: 'dd/MM/yyyy HH:mm' }}
                      </small>
                    </div>
                  </div>
                  <div class="d-flex" *ngIf="post.FacebookAccount?.FaceBookPageId">
                    <img
                      [src]="post.FacebookAccount.FacebookPagePicture"
                      class="rounded-circle profile-img me-2" [alt]="'productSocialMediaShares.profile' | transloco" style="width: 35px; height: 35px;"
                      (error)="onImageError($event)">
                    <div>
                      <div class="fw-semibold small-text mt-2">
                        {{ post.FacebookAccount.FacebookPageName  }}
                      </div>
                    </div>
                  </div>
                </div>


                <!-- Post Image -->
                <div class="centered-image-container mb-3 position-relative">
                  <img [src]="post.ImageURL || 'assets/images/No-Image.png'"
                    class="centered-image  cursor-pointer img-fluid rounded" [alt]="'productSocialMediaShares.postImage' | transloco"
                    (click)="goToProductDetails(post)">

                  <div *ngIf="post.UserName" class="share-badge position-absolute top-0  m-1 rounded"
                    [style.backgroundColor]="'#f79421'" [style.color]="'white'" [style.border]="'none'"
                    style="padding: 5px ; cursor: pointer;">
                    <div class="d-flex align-items-center">

                      <!-- Smaller Font for "Share By" -->
                      <div class="text-white fw-semibold cursor-pointer"
                        style=" text-decoration: underline;"
                        [pTooltip]="'productSocialMediaShares.viewUserProfile' | transloco: { userName: post.UserName }" tooltipPosition="top">
                        <!-- Underlined User Name -->
                        {{ post.UserName }}
                      </div>
                    </div>
                  </div>

                </div>

                <!-- Post Headline & Description -->
                <div *ngIf="post.HeadLine" class="fs-5 fw-bold mb-1 HeadLine">{{ post.HeadLine }}</div>
                <div *ngIf="post.Description" class="Description mb-3">{{ post.Description }}</div>

                <!-- Social Media Stats (Only Show If Account Is Active) -->
                <div *ngIf="post.FacebookAccount?.PageIsActive || post.InstagramAccount?.PageIsActive"
                  class="stats bg-light py-2 px-2 mt-2 rounded d-flex justify-content-between align-items-center">
                  <ng-container *ngIf="post.SocialMediaInsights.TotalLikes > 0 || post.SocialMediaInsights.TotalComments > 0; else noActivityMessage">
                    <div class="d-flex align-items-center">
                      <img *ngIf="post.PostedOn === 'Facebook'" src="assets/images/social/facebook.png"
                        class="rounded-circle social-media-logo me-1" width="16">
                      <img *ngIf="post.PostedOn === 'Instagram'" src="assets/images/social/instagram.png"
                        class="rounded-circle social-media-logo me-1" width="16">
                      <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.SocialMediaInsights.TotalLikes || 0 }} <i class="pi pi-thumbs-up"></i></span>
                    </div>
                    <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.SocialMediaInsights.TotalComments || 0 }} <i class="pi pi-comment"></i></span>
                    <span class="small-text" *ngIf="post.PostedOn === 'Facebook'">{{ post.SocialMediaInsights.TotalShares || 0 }} <i class="pi pi-share-alt"></i></span>
                  </ng-container>
                  <ng-template #noActivityMessage>
                    <div class="d-flex ms-3">
                        <ng-container *ngIf="post.PostedOn === 'Facebook'">
                          <img src="assets/images/social/facebook.png" class="rounded-circle social-media-logo me-1" width="15" height="15">
                        </ng-container>
                        <ng-container *ngIf="post.PostedOn === 'Instagram'">
                          <img src="assets/images/social/instagram.png" class="rounded-circle social-media-logo me-1" width="15" height="15">
                        </ng-container>
                        <span>{{ 'productSocialMediaShares.noActivityFound' | transloco }}</span>
                    </div>
                  </ng-template>
                </div>

                <!-- Post Status (Inactive Accounts) -->
                <div *ngIf="!post.FacebookAccount?.PageIsActive && post.PostedOn === 'Facebook'" class="mt-2 d-flex p-2 mb-0 rounded justify-content-center alert alert-warning" 
                style="opacity: 0.5; padding: 5px 10px;">
                    <!-- <ng-container *ngIf=""> -->
                      <img src="assets/images/social/facebook.png" class="rounded-pill social-media-logo me-1" width="30">
                      {{ 'productSocialMediaShares.accountDisconnected' | transloco }}
                    <!-- </ng-container> -->
                </div>
                <div *ngIf="!post.InstagramAccount?.PageIsActive && post.PostedOn === 'Instagram'" class="mt-2 d-flex p-2 mb-0 rounded justify-content-center alert alert-warning" 
                style="opacity: 0.5; padding: 5px 10px;">
                    <!-- <ng-container *ngIf=""> -->
                      <img src="assets/images/social/instagram.png" class="rounded-pill social-media-logo me-1" width="30">
                      {{ 'productSocialMediaShares.accountDisconnected' | transloco }}
                    <!-- </ng-container> -->
                </div>
           
              </div>
            </div>
            <div *ngIf="artistPosts.length == 0" class="d-flex justify-content-center mt-5">
              <span class="text-muted fs-5">{{ 'productSocialMediaShares.noArtistPostsFound' | transloco }}</span>
            </div>
          </p-tabPanel>
          <!-- Gallery Posts Tab -->
          <p-tabPanel [header]="'productSocialMediaShares.galleryPosts' | transloco" [disabled]="filter.productId == null && filter.filterUserId != null">
            <div class="row my-2 p-1">
              <div class="col d-flex justify-content-start p-2">
                <div class="d-flex justify-content-end align-items-center flex-wrap">
                  <div class="d-flex flex-column align-items-start me-3">
                    <div class="d-flex align-items-center">
                      <p-inputSwitch class="mt-1" [(ngModel)]="filterByFacebook" (onChange)="filterSocialPosts('gallery', 'Facebook', $event)"></p-inputSwitch>
                      <span class="ms-2 fw-semibold">{{ 'productSocialMediaShares.filterByFacebook' | transloco }}</span>
                    </div>
                  </div>
                  <div class="d-flex flex-column align-items-start me-3">
                    <div class="d-flex align-items-center">
                      <p-inputSwitch class="mt-1" [(ngModel)]="filterByInstagram" (onChange)="filterSocialPosts('gallery', 'Instagram',$event)"></p-inputSwitch>
                      <span class="ms-2 fw-semibold">{{ 'productSocialMediaShares.filterByInstagram' | transloco }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cmultical" *ngIf="galleryPosts.length > 0">
              <div class="post shadow mb-2 rounded" *ngFor="let post of galleryPosts">
                <!-- Post Header: Profile Image & Name -->
                <div class="d-flex align-items-center justify-content-between ">
                  <!-- Profile Image & Name -->
                  <div class="d-flex align-items-center mb-2">
                    <img
                      [src]="getProfilePicture(post)"
                      class="rounded-circle profile-img me-2" [alt]="'productSocialMediaShares.profile' | transloco" style="width: 35px; height: 35px;"
                      (error)="onImageError($event)">
                    <div>
                      <div class="fw-semibold small-text">
                        {{ getProfileName(post) }}
                      </div>
                      <small class="text-muted">
                        {{ post.CreatedDate | date: 'dd/MM/yyyy HH:mm' }}
                      </small>
                    </div>
                  </div>
                  <div class="d-flex" *ngIf="post.FacebookAccount?.FaceBookPageId">
                    <img
                      [src]="post.FacebookAccount.FacebookPagePicture"
                      class="rounded-circle profile-img me-2" [alt]="'productSocialMediaShares.profile' | transloco" style="width: 35px; height: 35px;"
                      (error)="onImageError($event)">
                    <div>
                      <div class="fw-semibold small-text mt-2">
                        {{ post.FacebookAccount.FacebookPageName  }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Post Image -->
                <div class="centered-image-container mb-3 position-relative">
                  <img [src]="post.ImageURL || 'assets/images/No-Image.png'"
                    class="centered-image cursor-pointer img-fluid rounded" [alt]="'productSocialMediaShares.postImage' | transloco"
                    (click)="goToProductDetails(post)">

                  <div *ngIf="post.UserName" class="share-badge position-absolute top-0  m-1 rounded"
                    [style.backgroundColor]="'#f79421'" [style.color]="'white'" [style.border]="'none'"
                    style="padding: 5px;  cursor: pointer;">
                    <div class="d-flex align-items-center">

                      <!-- Smaller Font for "Share By" -->
                      <div class="text-white fw-semibold cursor-pointer"
                       
                        style="text-decoration: underline;"
                        [pTooltip]="'productSocialMediaShares.viewUserProfile' | transloco: { userName: post.UserName }" tooltipPosition="top">
                        <!-- Underlined User Name -->
                        {{ post.UserName }}
                      </div>
                    </div>
                  </div>

                </div>

                <!-- Post Headline & Description -->
                <div *ngIf="post.HeadLine" class="fs-5 fw-bold mb-1 HeadLine">{{ post.HeadLine }}</div>
                <div *ngIf="post.Description" class="Description mb-3">{{ post.Description }}</div>

                <!-- Social Media Stats (Only Show If Account Is Active) -->
                <div *ngIf="post.FacebookAccount?.PageIsActive || post.InstagramAccount?.PageIsActive"
                  class="stats bg-light py-2 px-2 mt-2 rounded d-flex justify-content-between align-items-center">
                  <!-- <div class="d-flex align-items-center">
                    <img *ngIf="post.PostedOn === 'Facebook'" src="assets/images/social/facebook.png"
                      class="rounded-circle social-media-logo me-1" width="16">
                    <img *ngIf="post.PostedOn === 'Instagram'" src="assets/images/social/instagram.png"
                      class="rounded-circle social-media-logo me-1" width="16">
                    <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.TotalLikes || 0 }} <i class="pi pi-thumbs-up"></i></span>
                  </div>
                  <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.TotalComments || 0 }} <i class="pi pi-comment"></i></span>
                  <span class="small-text" *ngIf="post.PostedOn === 'Facebook'">{{ post.TotalShares || 0 }} <i class="pi pi-share-alt"></i></span> -->
                  <ng-container *ngIf="post.SocialMediaInsights.TotalLikes > 0 || post.SocialMediaInsights.TotalComments > 0; else noActivityMessage">
                    <div class="d-flex align-items-center">
                      <img *ngIf="post.PostedOn === 'Facebook'" src="assets/images/social/facebook.png"
                        class="rounded-circle social-media-logo me-1" width="16">
                      <img *ngIf="post.PostedOn === 'Instagram'" src="assets/images/social/instagram.png"
                        class="rounded-circle social-media-logo me-1" width="16">
                      <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.SocialMediaInsights.TotalLikes || 0 }} <i class="pi pi-thumbs-up"></i></span>
                    </div>
                    <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.SocialMediaInsights.TotalComments || 0 }} <i class="pi pi-comment"></i></span>
                    <span class="small-text" *ngIf="post.PostedOn === 'Facebook'">{{ post.SocialMediaInsights.TotalShares || 0 }} <i class="pi pi-share-alt"></i></span>
                  </ng-container>
                  <ng-template #noActivityMessage>
                    <div class="d-flex ms-3">
                        <ng-container *ngIf="post.PostedOn === 'Facebook'">
                          <img src="assets/images/social/facebook.png" class="rounded-circle social-media-logo me-1" width="15" height="15">
                        </ng-container>
                        <ng-container *ngIf="post.PostedOn === 'Instagram'">
                          <img src="assets/images/social/instagram.png" class="rounded-circle social-media-logo me-1" width="15" height="15">
                        </ng-container>
                        <span>{{ 'productSocialMediaShares.noActivityFound' | transloco }}</span>
                    </div>
                  </ng-template>
                </div>

                  <!-- Post Status (Inactive Accounts) -->
                  <div *ngIf="!post.FacebookAccount?.PageIsActive && post.PostedOn === 'Facebook'" class="mt-2 d-flex p-2 mb-0 rounded justify-content-center alert alert-warning" 
                  style="opacity: 0.5; padding: 5px 10px;">
                      <!-- <ng-container *ngIf=""> -->
                        <img src="assets/images/social/facebook.png" class="rounded-pill social-media-logo me-1" width="30">
                        {{ 'productSocialMediaShares.accountDisconnected' | transloco }}
                      <!-- </ng-container> -->
                  </div>
                  <div *ngIf="!post.InstagramAccount?.PageIsActive && post.PostedOn === 'Instagram'" class="mt-2 d-flex p-2 mb-0 rounded justify-content-center alert alert-warning" 
                  style="opacity: 0.5; padding: 5px 10px;">
                      <!-- <ng-container *ngIf=""> -->
                        <img src="assets/images/social/instagram.png" class="rounded-pill social-media-logo me-1" width="30">
                        {{ 'productSocialMediaShares.accountDisconnected' | transloco }}
                      <!-- </ng-container> -->
                  </div>

              </div>
            </div>


            <div *ngIf="galleryPosts.length == 0" class="d-flex justify-content-center mt-5">
              <span class="text-muted fs-5">{{ 'productSocialMediaShares.noGalleryPostsFound' | transloco }}</span>
            </div>
          </p-tabPanel>
        </p-tabView>
      </ng-container>
      <ng-container *ngIf="isGallery">
        <!-- <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="selectedTabIndex"> -->
          <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="selectedTabIndex">
            <p-tabPanel [header]="'productSocialMediaShares.artistPosts' | transloco" [disabled]="filter.productId == null && filter.filterUserId != null">
              <div class="row my-2 p-1">
                <div class="col d-flex justify-content-start p-2">
                  <div class="d-flex justify-content-end align-items-center flex-wrap">
                    <div class="d-flex flex-column align-items-start me-3">
                      <div class="d-flex align-items-center">
                        <p-inputSwitch class="mt-1" [(ngModel)]="filterByFacebook" (onChange)="filterSocialPosts('artist', 'Facebook',$event)"></p-inputSwitch>
                        <span class="ms-2 fw-semibold">{{ 'productSocialMediaShares.filterByFacebook' | transloco }}</span>
                      </div>
                    </div>
                    <div class="d-flex flex-column align-items-start me-3">
                      <div class="d-flex align-items-center">
                        <p-inputSwitch class="mt-1" [(ngModel)]="filterByInstagram" (onChange)="filterSocialPosts('artist', 'Instagram', $event)"></p-inputSwitch>
                        <span class="ms-2 fw-semibold">{{ 'productSocialMediaShares.filterByInstagram' | transloco }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cmultical" *ngIf="artistPosts.length > 0">
                <div class="post shadow mb-2 rounded" *ngFor="let post of artistPosts">
                  <!-- Post Header: Profile Image & Name -->
                  <div class="d-flex align-items-center justify-content-between ">
                    <!-- Profile Image & Name -->
                    <div class="d-flex align-items-center mb-2">
                      <img
                        [src]="getProfilePicture(post)"
                        class="rounded-circle profile-img me-2" [alt]="'productSocialMediaShares.profile' | transloco" style="width: 35px; height: 35px;"
                        (error)="onImageError($event)">
                      <div>
                        <div class="fw-semibold small-text">
                          {{ getProfileName(post) }}
                        </div>
                        <small class="text-muted">
                          {{ post.CreatedDate | date: 'dd/MM/yyyy HH:mm' }}
                        </small>
                      </div>
                    </div>
                    <div class="d-flex" *ngIf="post.FacebookAccount?.FaceBookPageId">
                      <img
                        [src]="post.FacebookAccount.FacebookPagePicture"
                        class="rounded-circle profile-img me-2" [alt]="'productSocialMediaShares.profile' | transloco" style="width: 35px; height: 35px;"
                        (error)="onImageError($event)">
                      <div>
                        <div class="fw-semibold small-text mt-2">
                          {{ post.FacebookAccount.FacebookPageName  }}
                        </div>
                      </div>
                    </div>
                  </div>
  
  
                  <!-- Post Image -->
                  <div class="centered-image-container mb-3 position-relative">
                    <img [src]="post.ImageURL || 'assets/images/No-Image.png'"
                      class="centered-image  cursor-pointer img-fluid rounded" [alt]="'productSocialMediaShares.postImage' | transloco"
                      (click)="goToProductDetails(post)">
  
                    <div *ngIf="post.UserName" class="share-badge position-absolute top-0  m-1 rounded"
                      [style.backgroundColor]="'#f79421'" [style.color]="'white'" [style.border]="'none'"
                      style="padding: 5px ; cursor: pointer;">
                      <div class="d-flex align-items-center">
  
                        <!-- Smaller Font for "Share By" -->
                        <div class="text-white fw-semibold cursor-pointer"
                          [routerLink]="['/view-artist-profile', post.UserId]"
                          style=" text-decoration: underline;"
                          [pTooltip]="'productSocialMediaShares.viewUserProfile' | transloco: { userName: post.UserName }" tooltipPosition="top">
                          <!-- Underlined User Name -->
                          {{ post.UserName }}
                        </div>
                      </div>
                    </div>
  
                  </div>
  
                  <!-- Post Headline & Description -->
                  <div *ngIf="post.HeadLine" class="fs-5 fw-bold mb-1 HeadLine">{{ post.HeadLine }}</div>
                  <div *ngIf="post.Description" class="Description mb-3">{{ post.Description }}</div>
  
                  <!-- Social Media Stats (Only Show If Account Is Active) -->
                  <div *ngIf="post.FacebookAccount?.PageIsActive || post.InstagramAccount?.PageIsActive"
                    class="stats bg-light py-2 px-2 mt-2 rounded d-flex justify-content-between align-items-center">
                    <!-- <div class="d-flex align-items-center">
                      <img *ngIf="post.PostedOn === 'Facebook'" src="assets/images/social/facebook.png"
                        class="rounded-circle social-media-logo me-1" width="16">
                      <img *ngIf="post.PostedOn === 'Instagram'" src="assets/images/social/instagram.png"
                        class="rounded-circle social-media-logo me-1" width="16">
                      <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.TotalLikes || 0 }} <i class="pi pi-thumbs-up"></i></span>
                    </div>
                    <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.TotalComments || 0 }} <i class="pi pi-comment"></i></span>
                    <span class="small-text" *ngIf="post.PostedOn === 'Facebook'">{{ post.TotalShares || 0 }} <i class="pi pi-share-alt"></i></span> -->
                    <ng-container *ngIf="post.SocialMediaInsights.TotalLikes > 0 || post.SocialMediaInsights.TotalComments > 0; else noActivityMessage">
                      <div class="d-flex align-items-center">
                        <img *ngIf="post.PostedOn === 'Facebook'" src="assets/images/social/facebook.png"
                          class="rounded-circle social-media-logo me-1" width="16">
                        <img *ngIf="post.PostedOn === 'Instagram'" src="assets/images/social/instagram.png"
                          class="rounded-circle social-media-logo me-1" width="16">
                        <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.SocialMediaInsights.TotalLikes || 0 }} <i class="pi pi-thumbs-up"></i></span>
                      </div>
                      <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.SocialMediaInsights.TotalComments || 0 }} <i class="pi pi-comment"></i></span>
                      <span class="small-text" *ngIf="post.PostedOn === 'Facebook'">{{ post.SocialMediaInsights.TotalShares || 0 }} <i class="pi pi-share-alt"></i></span>
                    </ng-container>
                    <ng-template #noActivityMessage>
                      <div class="d-flex ms-3">
                          <ng-container *ngIf="post.PostedOn === 'Facebook'">
                            <img src="assets/images/social/facebook.png" class="rounded-circle social-media-logo me-1" width="15" height="15">
                          </ng-container>
                          <ng-container *ngIf="post.PostedOn === 'Instagram'">
                            <img src="assets/images/social/instagram.png" class="rounded-circle social-media-logo me-1" width="15" height="15">
                          </ng-container>
                          <span>{{ 'productSocialMediaShares.noActivityFound' | transloco }}</span>
                      </div>
                    </ng-template>
                  </div>
  
                  <!-- Post Status (Inactive Accounts) -->
                  <div *ngIf="!post.FacebookAccount?.PageIsActive && post.PostedOn === 'Facebook'" class="mt-2 d-flex p-2 mb-0 rounded justify-content-center alert alert-warning" 
                  style="opacity: 0.5; padding: 5px 10px;">
                      <!-- <ng-container *ngIf=""> -->
                        <img src="assets/images/social/facebook.png" class="rounded-pill social-media-logo me-1" width="30">
                        {{ 'productSocialMediaShares.accountDisconnected' | transloco }}
                      <!-- </ng-container> -->
                  </div>
                  <div *ngIf="!post.InstagramAccount?.PageIsActive && post.PostedOn === 'Instagram'" class="mt-2 d-flex p-2 mb-0 rounded justify-content-center alert alert-warning" 
                  style="opacity: 0.5; padding: 5px 10px;">
                      <!-- <ng-container *ngIf=""> -->
                        <img src="assets/images/social/instagram.png" class="rounded-pill social-media-logo me-1" width="30">
                        {{ 'productSocialMediaShares.accountDisconnected' | transloco }}
                      <!-- </ng-container> -->
                  </div>
             
                </div>
              </div>
              <div *ngIf="artistPosts.length == 0" class="d-flex justify-content-center mt-5">
                <span class="text-muted fs-5">{{ 'productSocialMediaShares.noArtistPostsFound' | transloco }}</span>
              </div>
            </p-tabPanel>
            <!-- Gallery Posts Tab -->
            <p-tabPanel [header]="'productSocialMediaShares.galleryPosts' | transloco" [disabled]="filter.productId == null && filter.filterUserId != null">
              <div class="row my-2 p-1">
                <div class="col d-flex justify-content-start p-2">
                  <div class="d-flex justify-content-end align-items-center flex-wrap">
                    <div class="d-flex flex-column align-items-start me-3">
                      <div class="d-flex align-items-center">
                        <p-inputSwitch class="mt-1" [(ngModel)]="filterByFacebook" (onChange)="filterSocialPosts('gallery', 'Facebook', $event)"></p-inputSwitch>
                        <span class="ms-2 fw-semibold">{{ 'productSocialMediaShares.filterByFacebook' | transloco }}</span>
                      </div>
                    </div>
                    <div class="d-flex flex-column align-items-start me-3">
                      <div class="d-flex align-items-center">
                        <p-inputSwitch class="mt-1" [(ngModel)]="filterByInstagram" (onChange)="filterSocialPosts('gallery', 'Instagram', $event)"></p-inputSwitch>
                        <span class="ms-2 fw-semibold">{{ 'productSocialMediaShares.filterByInstagram' | transloco }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cmultical" *ngIf="galleryPosts.length > 0">
                <div class="post shadow mb-2 rounded" *ngFor="let post of galleryPosts">
                  <!-- Post Header: Profile Image & Name -->
                  <div class="d-flex align-items-center justify-content-between ">
                    <!-- Profile Image & Name -->
                    <div class="d-flex align-items-center mb-2">
                      <img
                        [src]="getProfilePicture(post)"
                        class="rounded-circle profile-img me-2" [alt]="'productSocialMediaShares.profile' | transloco" style="width: 35px; height: 35px;"
                        (error)="onImageError($event)">
                      <div>
                        <div class="fw-semibold small-text">
                          {{ getProfileName(post) }}
                        </div>
                        <small class="text-muted">
                          {{ post.CreatedDate | date: 'dd/MM/yyyy HH:mm' }}
                        </small>
                      </div>
                    </div>
                    <div class="d-flex" *ngIf="post.FacebookAccount?.FaceBookPageId">
                      <img
                        [src]="post.FacebookAccount.FacebookPagePicture"
                        class="rounded-circle profile-img me-2" [alt]="'productSocialMediaShares.profile' | transloco" style="width: 35px; height: 35px;"
                        (error)="onImageError($event)">
                      <div>
                        <div class="fw-semibold small-text mt-2">
                          {{ post.FacebookAccount.FacebookPageName  }}
                        </div>
                      </div>
                    </div>
                  </div>
  
                  <!-- Post Image -->
                  <div class="centered-image-container mb-3 position-relative">
                    <img [src]="post.ImageURL || 'assets/images/No-Image.png'"
                      class="centered-image cursor-pointer img-fluid rounded" [alt]="'productSocialMediaShares.postImage' | transloco"
                      (click)="goToProductDetails(post)">
  
                    <div *ngIf="post.UserName" class="share-badge position-absolute top-0  m-1 rounded"
                      [style.backgroundColor]="'#f79421'" [style.color]="'white'" [style.border]="'none'"
                      style="padding: 5px;  cursor: pointer;">
                      <div class="d-flex align-items-center">
  
                        <!-- Smaller Font for "Share By" -->
                        <div class="text-white fw-semibold cursor-pointer"
                          [routerLink]="['/profile', post.UserName]"
                          style="text-decoration: underline;"
                          [pTooltip]="'productSocialMediaShares.viewUserProfile' | transloco: { userName: post.UserName }" tooltipPosition="top">
                          <!-- Underlined User Name -->
                          {{ post.UserName }}
                        </div>
                      </div>
                    </div>
  
                  </div>
  
                  <!-- Post Headline & Description -->
                  <div *ngIf="post.HeadLine" class="fs-5 fw-bold mb-1 HeadLine">{{ post.HeadLine }}</div>
                  <div *ngIf="post.Description" class="Description mb-3">{{ post.Description }}</div>
  
                  <!-- Social Media Stats (Only Show If Account Is Active) -->
                  <div *ngIf="post.FacebookAccount?.PageIsActive || post.InstagramAccount?.PageIsActive"
                    class="stats bg-light py-2 px-2 mt-2 rounded d-flex justify-content-between align-items-center">
                    <!-- <div class="d-flex align-items-center">
                      <img *ngIf="post.PostedOn === 'Facebook'" src="assets/images/social/facebook.png"
                        class="rounded-circle social-media-logo me-1" width="16">
                      <img *ngIf="post.PostedOn === 'Instagram'" src="assets/images/social/instagram.png"
                        class="rounded-circle social-media-logo me-1" width="16">
                      <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.TotalLikes || 0 }} <i class="pi pi-thumbs-up"></i></span>
                    </div>
                    <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.TotalComments || 0 }} <i class="pi pi-comment"></i></span>
                    <span class="small-text" *ngIf="post.PostedOn === 'Facebook'">{{ post.TotalShares || 0 }} <i class="pi pi-share-alt"></i> </span> -->
                    <ng-container *ngIf="post.SocialMediaInsights.TotalLikes > 0 || post.SocialMediaInsights.TotalComments > 0; else noActivityMessage">
                      <div class="d-flex align-items-center">
                        <img *ngIf="post.PostedOn === 'Facebook'" src="assets/images/social/facebook.png"
                          class="rounded-circle social-media-logo me-1" width="16">
                        <img *ngIf="post.PostedOn === 'Instagram'" src="assets/images/social/instagram.png"
                          class="rounded-circle social-media-logo me-1" width="16">
                        <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.SocialMediaInsights.TotalLikes || 0 }} <i class="pi pi-thumbs-up"></i></span>
                      </div>
                      <span class="small-text" *ngIf="post.PostedOn === 'Facebook' || post.PostedOn === 'Instagram'">{{ post.SocialMediaInsights.TotalComments || 0 }} <i class="pi pi-comment"></i></span>
                      <span class="small-text" *ngIf="post.PostedOn === 'Facebook'">{{ post.SocialMediaInsights.TotalShares || 0 }} <i class="pi pi-share-alt"></i></span>
                    </ng-container>
                    <ng-template #noActivityMessage>
                      <div class="d-flex ms-3">
                          <ng-container *ngIf="post.PostedOn === 'Facebook'">
                            <img src="assets/images/social/facebook.png" class="rounded-circle social-media-logo me-1" width="15" height="15">
                          </ng-container>
                          <ng-container *ngIf="post.PostedOn === 'Instagram'">
                            <img src="assets/images/social/instagram.png" class="rounded-circle social-media-logo me-1" width="15" height="15">
                          </ng-container>
                          <span>{{ 'productSocialMediaShares.noActivityFound' | transloco }}</span>
                      </div>
                    </ng-template>
                  </div>
  
                    <!-- Post Status (Inactive Accounts) -->
                    <div *ngIf="!post.FacebookAccount?.PageIsActive && post.PostedOn === 'Facebook'" class="mt-2 d-flex p-2 mb-0 rounded justify-content-center alert alert-warning" 
                    style="opacity: 0.5; padding: 5px 10px;">
                      <!-- <ng-container *ngIf=""> -->
                        <img src="assets/images/social/facebook.png" class="rounded-pill social-media-logo me-1" width="30">
                        {{ 'productSocialMediaShares.accountDisconnected' | transloco }}
                      <!-- </ng-container> -->
                    </div>
                    <div *ngIf="!post.InstagramAccount?.PageIsActive && post.PostedOn === 'Instagram'" class="mt-2 d-flex p-2 mb-0 rounded justify-content-center alert alert-warning" 
                    style="opacity: 0.5; padding: 5px 10px;">
                      <!-- <ng-container *ngIf=""> -->
                        <img src="assets/images/social/instagram.png" class="rounded-pill social-media-logo me-1" width="30">
                        {{ 'productSocialMediaShares.accountDisconnected' | transloco }}
                      <!-- </ng-container> -->
                    </div>
  
                </div>
              </div>
  
  
              <div *ngIf="galleryPosts.length == 0" class="d-flex justify-content-center mt-5">
                <span class="text-muted fs-5">{{ 'productSocialMediaShares.noGalleryPostsFound' | transloco }}</span>
              </div>
            </p-tabPanel>
          </p-tabView>
        <!-- </p-tabView> -->
      </ng-container>
    </div>
  </div>
</div>